import React from 'react'
import { Placeholder } from 'semantic-ui-react'



const PlaceholderExampleHeaderImage = (props) => {
    if (props.repeat) {
        let repratPlaceholder = []
        for (let i = 0; i < props.repeat; i++) {
            repratPlaceholder.push(
                <div key={i} className="pad_10 bg-white" style={{ margin: "0 0 10px 0" }}>
                    <Placeholder>
                        <Placeholder.Header image>
                            <Placeholder.Line />
                            <Placeholder.Line />
                        </Placeholder.Header>
                    </Placeholder>
                </div>
            )
        }
        return repratPlaceholder;
    } else {
        return <div className="pad_10 bg-white" style={{ margin: "0 0 10px 0" }}>
            <Placeholder>
                <Placeholder.Header image>
                    <Placeholder.Line />
                    <Placeholder.Line />
                </Placeholder.Header>
            </Placeholder>
        </div>;
    }
}

export default PlaceholderExampleHeaderImage